var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('default-bar'),_c('default-drawer'),(_vm.appLoaded)?_c('default-view'):_vm._e(),_c('default-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }